'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = forEach;
function forEachObject(obj, fn, path, level) {
  for (var key in obj) {
    var deepPath = path ? path + '.' + key : key;
    var result = fn.call(obj, obj[key], key, obj, deepPath, level);
    if (result !== false) forEach(obj[key], fn, deepPath, level + 1);
  }
}

function forEachArray(array, fn, path, level) {
  var deepPath = '';

  array.forEach(function (value, index, arr) {
    deepPath = path ? path + '.' + index : index.toString();
    var result = fn.call(arr, value, index, arr, deepPath, level);
    if (result !== false) forEach(arr[index], fn, deepPath, level + 1);
  });
}

function forEach(value, fn, path) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  path = path || '';

  if (Array.isArray(value)) forEachArray(value, fn, path, level);else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !(value instanceof Error)) forEachObject(value, fn, path, level);
}